import React, { useContext, useEffect, useState } from "react";
import { Row, Col, Card, Form, Input, Button, Divider, Avatar } from "antd";
import { UserOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { getDatabase, ref, update } from "firebase/database";
import { auth } from "../../../firebase.config";

import {
  getStorage,
  ref as storageRef,
  uploadBytes,
  getDownloadURL,
} from "firebase/storage";
import { UploadOutlined } from "@ant-design/icons";
import { Upload, message } from "antd";
import ImgCrop from "antd-img-crop";

import { UserContext } from "../../../context/UserContext";
import { openError, openSuccess } from "../../../utils/helper/message";
import { notification, Typography } from "antd";

const { Item } = Form;

const MyProfilePage = () => {
  const { user, setUser } = useContext(UserContext);
  const [previewImage, setPreviewImage] = useState("");
  const [form] = Form.useForm();
  const [api, contextHolder] = notification.useNotification();
  const navigate = useNavigate();

  useEffect(() => {
    if (user?.profileImage) {
      setPreviewImage(user.profileImage);
    }
    if (user) {
      form.setFieldsValue({
        firstName: user.firstname || "",
        lastName: user.lastname || "",
      });
    }
  }, [user, form, navigate, api]);

  const handleImageUpload = async (file) => {
    if (!user?.uid) {
      console.error("Missing UID. Cannot upload image.");
      return;
    }

    try {
      // Local preview
      if (file instanceof Blob) {
        const tempUrl = URL.createObjectURL(file);
        setPreviewImage(tempUrl);
      }

      const storage = getStorage();
      const imageRef = storageRef(
        storage,
        `profile_pics/profile_${Date.now()}.jpg`
      );
      const snapshot = await uploadBytes(imageRef, file);

      const url = await getDownloadURL(imageRef);

      const db = getDatabase();
      await update(ref(db, `landlords/${user.uid}`), { profileImage: url });

      console.log("Profile image URL saved to DB");

      setUser((prev) => ({
        ...prev,
        profileImage: url,
      }));

      message.success("Profile image uploaded!");
    } catch (err) {
      console.error("Image upload failed:", err);
      message.error("Image upload failed. Check console.");
    }
  };

  const handleSubmit = async (values) => {
    if (!user?.uid) return;

    try {
      const db = getDatabase();
      await update(ref(db, `landlords/${user.uid}`), {
        firstname: values.firstName,
        lastname: values.lastName,
      });

      setUser((prev) => ({
        ...prev,
        firstname: values.firstName,
        lastname: values.lastName,
      }));

      openSuccess(api, "Profile updated successfully");
    } catch (err) {
      console.error("Failed to update profile:", err);
      openError(api, err.message || "Profile update failed");
    }
  };

  return (
    <>
      {contextHolder}
      <Row justify="center" style={{ marginTop: "2rem" }}>
        <Col xs={24} sm={20} md={16} lg={12}>
          <Card
            title={
              <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                <Avatar
                  size={64}
                  src={user?.profileImage}
                  icon={<UserOutlined />}
                />

                <span>My Profile</span>
              </div>
            }
            bordered={false}
          >
            <ImgCrop rotationSlider>
              <Upload
                customRequest={({ file, onSuccess }) => {
                  const rawFile = file?.originFileObj || file;
                  if (!rawFile) {
                    console.error("No valid file found in Upload component.");
                    return;
                  }

                  handleImageUpload(rawFile).then(() => {
                    onSuccess?.("ok");
                  });
                }}
                showUploadList={false}
                accept="image/*"
              >
                <Button icon={<UploadOutlined />} style={{ marginBottom: 16 }}>
                  Upload Profile Image
                </Button>
              </Upload>
            </ImgCrop>

            {previewImage && (
              <div style={{ marginBottom: 16 }}>
                <img
                  src={previewImage}
                  alt="Preview"
                  style={{
                    width: 120,
                    height: 120,
                    borderRadius: "50%",
                    objectFit: "cover",
                  }}
                />
              </div>
            )}

            <Form layout="vertical" form={form} onFinish={handleSubmit}>
              <Item
                label="First Name"
                name="firstName"
                rules={[{ required: true, message: "First name is required" }]}
              >
                <Input placeholder="Enter first name" size="large" />
              </Item>

              <Item
                label="Last Name"
                name="lastName"
                rules={[{ required: true, message: "Last name is required" }]}
              >
                <Input placeholder="Enter last name" size="large" />
              </Item>

              <Divider />

              <Item>
                <Button type="primary" htmlType="submit" block size="large">
                  Save Changes
                </Button>
              </Item>
            </Form>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default MyProfilePage;
